import gql from 'graphql-tag';

export const GET_PLAN_PAYMENT_METHOD = gql`
  query GetPlanPaymentMethod($planId: Int!) {
    plan(id: $planId) {
      id
      displayName
      paymentMethodId
    }
  }
`;

export const getPlanPaymentMethodMock = {
  plan: {
    id: 1,
    displayName: 'Plan 1',
    paymentMethodId: 1,
  },
};
